import "./App.css";
import { useState } from "react";
import {
  FormHelperText,
  IconButton,
  OutlinedInput,
  Backdrop,
  CircularProgress,
  ThemeProvider,
} from "@mui/material";
import axios from "axios";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import theme from "./theme";

function App() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [passVisible, setPassVisible] = useState(false);

  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const handleSignup = () => {
    setLoader(true);
    if (!Boolean(email) || !emailRegex.test(email)) {
      setEmailError(true);
      setEmailErrorMessage("Please enter a valid email.");
      setLoader(false);
      return;
    }
    if (!Boolean(password)) {
      setPasswordError(true);
      setLoader(false);
      return;
    }
    setEmailError(false);
    setPasswordError(false);
    let data = {
      email: email,
      password: password,
    };
    axios.post("https://api.fabloq.com/user/signup/", data).then((res) => {
      setLoader(false);
      if (res.status === 226) {
        setEmailError(true);
        setEmailErrorMessage(res.data.message);
        return;
      }
      setEmailError(false);
      setPasswordError(false);
      let token = res.data.token;
      localStorage.setItem("token", "Token " + token);
      window.location.replace("https://www.fabloq.com/app");
    });
  };
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="primary" />
        </Backdrop>
        <nav>
          <div class="nav-container">
            <a href="https://www.fabloq.com">
              <img
                src="images/logo.png"
                alt="logo"
                class="logo-image"
                width="96"
              />
            </a>
            <a
              href="http://www.fabloq.com/docs"
              className="nav-doc-button mobile-hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clip-path="url(#clip0_239_162)">
                  <path
                    d="M17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C5.05 4.5 3.51 4.72 2.22 5.29C1.49 5.62 1 6.33 1 7.14V18.42C1 19.72 2.22 20.68 3.48 20.36C4.46 20.11 5.5 20 6.5 20C8.06 20 9.72 20.26 11.06 20.92C11.66 21.22 12.34 21.22 12.93 20.92C14.27 20.25 15.93 20 17.49 20C18.49 20 19.53 20.11 20.51 20.36C21.77 20.69 22.99 19.73 22.99 18.42V7.14C22.99 6.33 22.5 5.62 21.77 5.29C20.49 4.72 18.95 4.5 17.5 4.5ZM21 17.23C21 17.86 20.42 18.32 19.8 18.21C19.05 18.07 18.27 18.01 17.5 18.01C15.8 18.01 13.35 18.66 12 19.51V8C13.35 7.15 15.8 6.5 17.5 6.5C18.42 6.5 19.33 6.59 20.2 6.78C20.66 6.88 21 7.29 21 7.76V17.23Z"
                    fill="white"
                  />
                  <path
                    d="M13.98 11.0101C13.66 11.0101 13.37 10.8101 13.27 10.4901C13.14 10.1001 13.36 9.6701 13.75 9.5501C15.29 9.0501 17.28 8.8901 19.11 9.1001C19.52 9.1501 19.82 9.5201 19.77 9.9301C19.72 10.3401 19.35 10.6401 18.94 10.5901C17.32 10.4001 15.55 10.5501 14.21 10.9801C14.13 10.9901 14.05 11.0101 13.98 11.0101Z"
                    fill="white"
                  />
                  <path
                    d="M13.98 13.67C13.66 13.67 13.37 13.47 13.27 13.15C13.14 12.76 13.36 12.33 13.75 12.21C15.28 11.71 17.28 11.55 19.11 11.76C19.52 11.81 19.82 12.18 19.77 12.59C19.72 13 19.35 13.3 18.94 13.25C17.32 13.06 15.55 13.21 14.21 13.64C14.13 13.66 14.05 13.67 13.98 13.67Z"
                    fill="white"
                  />
                  <path
                    d="M13.98 16.3299C13.66 16.3299 13.37 16.1299 13.27 15.8099C13.14 15.4199 13.36 14.9899 13.75 14.8699C15.28 14.3699 17.28 14.2099 19.11 14.4199C19.52 14.4699 19.82 14.8399 19.77 15.2499C19.72 15.6599 19.35 15.9499 18.94 15.9099C17.32 15.7199 15.55 15.8699 14.21 16.2999C14.13 16.3199 14.05 16.3299 13.98 16.3299Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_239_162">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Documentation
            </a>
          </div>
        </nav>
        <div className="content">
          <div className="content-wallpaper mobile-hidden">
            <p className="content-message">Namaste!</p>
          </div>
          <div className="content-auth-container">
            <div className="content-auth">
              <div className="auth-form">
                <h2 className="auth-form-header">Signup</h2>
                <p className="auth-form-des">Create a new account.</p>
                <div className="auth-text-input-container auth-input-email">
                  <p className="auth-input-label">Email</p>
                  <OutlinedInput
                    className="outlined-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={emailError}
                  ></OutlinedInput>
                  <FormHelperText error={emailError}>
                    {emailError ? emailErrorMessage : ""}
                  </FormHelperText>
                </div>
                <div className="auth-text-input-container auth-input-password">
                  <p className="auth-input-label">Password</p>
                  <OutlinedInput
                    className="outlined-input"
                    type={passVisible ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={passwordError}
                    endAdornment={
                      <IconButton
                        onClick={() => {
                          setPassVisible(!passVisible);
                        }}
                      >
                        {passVisible ? (
                          <VisibilityOffIcon
                            style={{
                              color: "#b4b4b4",
                            }}
                          />
                        ) : (
                          <VisibilityIcon
                            style={{
                              color: "#b4b4b4",
                            }}
                          />
                        )}
                      </IconButton>
                    }
                  ></OutlinedInput>
                  <FormHelperText error={passwordError}>
                    {passwordError ? "Please enter a password." : ""}
                  </FormHelperText>
                </div>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSignup();
                  }}
                  className="auth-button"
                >
                  Sign Up
                </a>
                <p className="auth-bottom-link">
                  Have an account?{" "}
                  <a href="https://www.fabloq.com/app">Sign In Now</a>
                </p>
              </div>
              <p className="auth-terms">
                By continuing, you agree to Fabloq's{" "}
                <a href="https://www.fabloq.com/terms.html">Terms of Service</a>{" "}
                and{" "}
                <a href="https://www.fabloq.com/privacy.html">Privacy Policy</a>
                , and to receive periodic emails with updates.
              </p>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
